// React imports
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

// Components
import Button from '../components/Button.tsx';
import Container from '../components/Container.tsx';

// Librairie
import gsap from 'gsap';

// Contextes
import { useInTheGame } from '../utils/InTheGameContexte.tsx';

function Accueil() {
    const [isClicked, setIsClicked] = useState(false);
    const [pageToNavigate, setPageToNavigate] = useState('');
    const navigate = useNavigate();

    const containerRef = useRef<HTMLDivElement>(null);

    // Désactiver le jeu - pour affichage logo
    const { toggleGame } = useInTheGame();
    useEffect(() => {
        toggleGame(false);
    }, []);

    // Animation chargement page
    useEffect(() => {
        const pageEl = document.querySelector('.accueil') as HTMLElement | null;
        if (pageEl) {
            gsap.set(pageEl, {
                xPercent: -100,
            });
            gsap.to(pageEl, {
                xPercent: 0,
                duration: 0.5,
                ease: 'power1.in',
                stagger: 0.1,
                opacity: 1,
                delay: 0.2,
            });
        }
    }, []);

    // Animation de sortie de la page
    useEffect(() => {
        // Ciblez les éléments à animer. Adaptez le sélecteur à vos besoins.
        if (containerRef.current) {
            const targets = containerRef.current.querySelectorAll('.accueilAnimation');

            if (isClicked) {
                // Déplacer les éléments vers la gauche (-100%)
                gsap.to(targets, {
                    xPercent: -100,
                    duration: 0.5,
                    ease: 'power1.out',
                    stagger: 0.1,
                    opacity: 0,
                    onComplete: () => navigate(pageToNavigate),
                });
            } else {
                // Remettre les éléments en position initiale
                gsap.to(targets, {
                    delay: 0.5,
                    xPercent: 0,
                    duration: 0.5,
                    ease: 'power1.in',
                    stagger: 0.1,
                    opacity: 1,
                });
            }
        }
    }, [isClicked]);

    return (
        <Container
            color='darkBlue'
            ref={containerRef}
        >
            <div className='accueil accueilAnimation'>
                <p className='accueilAnimation accueilText accueilText--margin'>
                    Êtes-vous prêts à tester vos connaissances sur l’hépatite C ?
                    <i className='accueilText accueilAnimation'>
                        Pour commencer choisissez un mode de jeu.
                    </i>
                </p>
                <Button
                    scene='menu'
                    colorName='blue'
                    isSelected={false}
                    onClick={() => {
                        setIsClicked(!isClicked);
                        setPageToNavigate('/entrainement');
                    }}
                >
                    Entraînement
                </Button>

                <Button
                    scene='menu'
                    colorName='blue'
                    isSelected={false}
                    onClick={() => {
                        setIsClicked(!isClicked);
                        setPageToNavigate('/classique');
                    }}
                >
                    Classique
                </Button>

                <Button
                    scene='menu'
                    colorName='red'
                    isSelected={false}
                    onClick={() => {
                        setIsClicked(!isClicked);
                        setPageToNavigate('/expert');
                    }}
                >
                    Expert
                </Button>
            </div>
        </Container>
    );
}

export default Accueil;
